// NATIVE
import * as React from 'react';

// INSTALLED
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import DeleteIcon from '@mui/icons-material/Delete';
import Menu, { MenuProps } from '@mui/material/Menu';
import { styled, alpha } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { DialogArea } from '../modals/areas/DialogArea';
import TableContainer from '@mui/material/TableContainer';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Card, Chip, Pagination, TablePagination } from '@mui/material';

// CUSTOM
import { paddingCardsTables, timeToClosedToast } from '../../commons';
import MultipleSnackbars from '../MultipleSnackbars';
import { closeSessionGlobal, formatDateToYmd, hasPemissions } from '../../commons/utils';
import { showNumberRowsTable } from '../../commons/utils/values';
import { EditarDialogArea } from '../modals/areas/EditarDialogArea';
import { DetalleDialogArea } from '../modals/areas/DetalleDialogArea';
import { ModalSessionExpired } from '../generics/ModalSessionExpired';
import {
  getAreasByPagination,
  getAreaStore,
  storeActiveArea,
  storeDesactiveArea,
  storeDetailAreas,
  storeEditarAreas,
} from '../../store/areas';
import { SnackAlert } from '../SnackAlert';
import {
  getCodeExpressCheckinByPagination,
  getExpressCheckinStore,
  storeActiveCodeExpressCheckin,
  storeDesactiveCodeExpressCheckin,
  storeEditarExpressCheckin,
} from '../../store/express-checkin';
import { EditarDialogExpressCheckin } from '../modals/checkingExpress/EditarDialogExpressCheckin';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.secondary.contrastText,
    fontSize: 15,
    fontWeight: 700,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontWeight: 500,
    color: '#2e263de6',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export const CodigosExpresCheckingTable = () => {
  // DISPATCH
  const dispatch = useDispatch();

  // REDUX
  const { expressCheckinList }: any = useSelector((state: any) => state.expressCheckin);

  // USE STATE
  const [dataTableList, setDataTable] = React.useState([]);
  const [pagination, setPagination] = React.useState<any>({
    page: 1,
    take: 1,
    itemCount: 1,
    pageCount: 1,
    hasPreviousPage: false,
    hasNextPage: false,
  });

  const [openElem, setOpenElem] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const [canEdit, setCanEdit] = React.useState<boolean>(false);
  const [canDelete, setCanDelete] = React.useState<boolean>(false);
  const [canRestore, setCanRestore] = React.useState<boolean>(false);

  const [page, setPage] = React.useState(0);
  const [pagePagination, setPagePagination] = React.useState(1);
  const [itemCountPagination, setItemCountPagination] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(showNumberRowsTable);

  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);

  const [open_d, setOpen] = React.useState(false);
  const [buttons, setButtons] = React.useState(false);
  const [modalDetalle, setModalDetalle] = React.useState(false);
  const [modalEditar, setModalEditar] = React.useState(false);

  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [alert_snack, setAlertSnack] = React.useState(false);
  const [msgSnack, setMsgSnack] = React.useState({
    msg: '',
    status: 'success',
  });

  // USE EFFECT
  React.useEffect(() => {
    if (expressCheckinList.data && expressCheckinList.data.length > 0) {
      setDataTable(expressCheckinList.data);
      setPagination({
        page: expressCheckinList.meta.page,
        take: expressCheckinList.meta.take,
        itemCount: expressCheckinList.meta.itemCount,
        pageCount: expressCheckinList.meta.pageCount,
        hasPreviousPage: expressCheckinList.meta.hasPreviousPage,
        hasNextPage: expressCheckinList.meta.hasNextPage,
      });
      setItemCountPagination(expressCheckinList.meta.pageCount);
    }
  }, [expressCheckinList]);

  // USE EFFECT
  React.useEffect(() => {
    // HERE LOAD THE DATA FOR DATATABLE
    getDataExpressChecking();
  }, []);

  React.useEffect(() => {
    checkEdit();
  }, []);

  React.useEffect(() => {
    checkCanDelete();
  }, []);

  React.useEffect(() => {
    checkRestore();
  }, []);

  // CONST STYLES
  const StyledMenu = styled((props: MenuProps) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    />
  ))(({ theme }) => ({
    '& .MuiPaper-root': {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 180,
      color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
      boxShadow:
        'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      '& .MuiMenu-list': {
        padding: '7px 0',
      },
      '& .MuiMenuItem-root': {
        '& .MuiSvgIcon-root': {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        '&:active': {
          backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
        },
      },
    },
  }));

  const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: 'wheat',
    padding: theme.spacing(8),
    textAlign: 'center',
  }));

  // CONST VALUE
  const open = Boolean(anchorEl);

  // CONST FUNCTIONS

  const getDataExpressChecking = async () => {
    const response = await dispatch(getExpressCheckinStore());

    await validateResponse(response, ' (Listar Codigo) ');
  };

  const handleClick = (elem: any) => (event: any) => {
    setAnchorEl(event.currentTarget);
    setOpenElem(elem);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenElem(null);
  };

  const openDialogDetalle = async (areaId: string) => {
    setAnchorEl(null);
    setOpenElem(null);
    setButtons(false);

    const response = await dispatch(storeDetailAreas(areaId));

    const result = await validateResponse(response, ' (Detalle Codigo) ');

    if (!result) {
      return false;
    }

    setModalDetalle(response);
  };

  const openDialogEditar = async (codeExpressCheckinId: string) => {
    setAnchorEl(null);
    setOpenElem(null);
    setButtons(false);

    const response = await dispatch(storeEditarExpressCheckin(codeExpressCheckinId));

    setAnchorEl(null);
    setOpenElem(null);
    setButtons(false);

    const result = await validateResponse(response, ' (Detalle Codigo) ');

    if (!result) {
      return false;
    }

    setModalEditar(true);
  };

  const desactiveArea = async (codeExpressCheckinId: string) => {
    setAnchorEl(null);
    setOpenElem(null);
    setButtons(false);

    const response = await dispatch(storeDesactiveCodeExpressCheckin(codeExpressCheckinId));

    await validateResponse(response, ' (Desactivar Codigo) ');
  };

  const restoreArea = async (codeExpressCheckinId: string) => {
    setAnchorEl(null);
    setOpenElem(null);
    setButtons(false);

    const response = await dispatch(storeActiveCodeExpressCheckin(codeExpressCheckinId));

    await validateResponse(response, ' (Restaurar Codigo) ');
  };

  const handleCloseModalCrear = () => {
    setOpen(false);
  };

  const handleCloseModalDetail = () => {
    setModalDetalle(false);
  };

  const handleCloseModalEditar = () => {
    setModalEditar(false);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);

    setPage(0);
  };

  const changePaginationPage = async (event: React.ChangeEvent<unknown>, value: number) => {
    setPagePagination(value);

    const response = await dispatch(getCodeExpressCheckinByPagination(value));

    await validateResponse(response, ' (Listar Codigo) ');
  };

  const validateResponse = async (response: any, textActionConcat: string) => {
    if (response.code == 401) {
      await localStorage.removeItem('lastSelectedQypht');
      await closeSessionGlobal();
      setModalSessionExpired(true);
      return false;
    }

    // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION
    if (!response.ok && response.code == 403) {
      const errors: any = {
        msg: response.errors[0] + ' ' + textActionConcat,
        status: 'error',
      };

      await setMsgSnack(errors);
      await setAlertSnack(true);

      return false;
    }

    // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO
    if (!response.ok && response.code == 400) {
      const errors: any = [];

      response.errors.forEach((element: any) => {
        errors.push({
          type: 'error',
          text: element,
        });
      });

      setMessagesAlerts(errors);
      return false;
    }

    return true;
  };

  const checkEdit = async () => {
    const hasPermissionsEdit = await hasPemissions(
      'modulo.hotel',
      'modulo.codigosexpresscheckin',
      'edit'
    );

    if (hasPermissionsEdit) {
      setCanEdit(true);
    }
  };

  const checkCanDelete = async () => {
    const hasPermissionsDelete = await hasPemissions(
      'modulo.hotel',
      'modulo.codigosexpresscheckin',
      'delete'
    );

    if (hasPermissionsDelete) {
      setCanDelete(true);
    }
  };

  const checkRestore = async () => {
    const hasPermissionsRestore = await hasPemissions(
      'modulo.hotel',
      'modulo.codigosexpresscheckin',
      'restore'
    );

    if (hasPermissionsRestore) {
      setCanRestore(true);
    }
  };

  return (
    <>
      <ModalSessionExpired open={modalSessionExpired} />
      <SnackAlert
        open={alert_snack}
        onclick={setAlertSnack}
        text={msgSnack.msg}
        severity={msgSnack.status}
      />

      {/* <DetalleDialogArea open={modalDetalle} handleCloseModalDetail={handleCloseModalDetail} /> */}
      <EditarDialogExpressCheckin
        open={modalEditar}
        btnSubmiting={false}
        handleCloseModalEditar={handleCloseModalEditar}
      />

      {dataTableList.length > 0 ? (
        <>
          <Card
            sx={{
              display: 'flex',
              alignItems: 'center',
              p: 3,
              borderRadius: 2,
              boxShadow: 3,
              bgcolor: 'background.paper',
              marginTop: paddingCardsTables,
            }}
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Codigo</StyledTableCell>
                    <StyledTableCell>Adultos</StyledTableCell>
                    <StyledTableCell>Menores</StyledTableCell>
                    <StyledTableCell>Empresarial?</StyledTableCell>
                    <StyledTableCell>Creado por</StyledTableCell>
                    <StyledTableCell>Fecha creacion</StyledTableCell>
                    <StyledTableCell>Estado</StyledTableCell>
                    <StyledTableCell>Acciones</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataTableList
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row: any, index: any) => (
                      <StyledTableRow key={index + 1}>
                        <StyledTableCell component="th" scope="row">
                          {row.code}
                        </StyledTableCell>
                        <StyledTableCell>{row.adults}</StyledTableCell>
                        <StyledTableCell>{row.minors}</StyledTableCell>
                        <StyledTableCell>{row.isBussines ? 'Si' : 'No'}</StyledTableCell>
                        <StyledTableCell>{row.createdBy.name || 'N/A'}</StyledTableCell>
                        <StyledTableCell>{formatDateToYmd(row.createdAt) || 'N/A'}</StyledTableCell>
                        <StyledTableCell>
                          {row.status ? (
                            <Chip
                              size="small"
                              label="Activo"
                              sx={{ color: '#5DCC0A', background: '#E4F6D6', fontWeight: 700 }}
                            />
                          ) : (
                            <Chip
                              size="small"
                              label="Inactivo"
                              sx={{ color: '#FF4C51', background: '#FFE2E3', fontWeight: 700 }}
                            />
                          )}
                        </StyledTableCell>
                        <StyledTableCell>
                          {
                            <div>
                              <Button
                                id={`demo-customized-button-${index + 1}`}
                                aria-controls={
                                  open ? `demo-customized-menu-${index + 1}` : undefined
                                }
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                variant="text"
                                disableElevation
                                onClick={handleClick(row)}
                                endIcon={<KeyboardArrowDownIcon />}
                              >
                                Acciones
                              </Button>
                              <StyledMenu
                                id={`demo-customized-menu-${index + 1}`}
                                MenuListProps={{
                                  'aria-labelledby': `demo-customized-button-${index + 1}`,
                                }}
                                anchorEl={anchorEl}
                                open={openElem === row}
                                onClose={handleClose}
                              >
                                {row.status ? (
                                  <div>
                                    {/* <MenuItem onClick={ () => openDialogDetalle(row.id) }  disableRipple>
                                                      <VisibilityIcon />
                                                        Detalle 
                                                      </MenuItem> */}

                                    <Divider sx={{ my: 0.5 }} />
                                    {canEdit && (
                                      <MenuItem
                                        onClick={() => openDialogEditar(row.id)}
                                        disableRipple
                                      >
                                        <EditIcon />
                                        Editar
                                      </MenuItem>
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}

                                {row.status ? (
                                  <div>
                                    {canDelete && (
                                      <>
                                        <Divider sx={{ my: 0.5 }} />
                                        <MenuItem
                                          onClick={() => desactiveArea(row.id)}
                                          disableRipple
                                        >
                                          <DeleteIcon />
                                          Desactivar
                                        </MenuItem>
                                      </>
                                    )}
                                  </div>
                                ) : (
                                  <div>
                                    {canRestore && (
                                      <>
                                        <Divider sx={{ my: 0.5 }} />
                                        <MenuItem onClick={() => restoreArea(row.id)} disableRipple>
                                          <DeleteIcon />
                                          Activar
                                        </MenuItem>
                                      </>
                                    )}
                                  </div>
                                )}
                              </StyledMenu>
                            </div>
                          }
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
          <TablePagination
            rowsPerPageOptions={[5, 10]}
            labelRowsPerPage={'Filas por pagina'}
            labelDisplayedRows={({ from, to, count }) => ` ${from}-${to} de  ${count} `}
            component="div"
            count={pagination.itemCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 2,
              marginBottom: 2,
            }}
          >
            <Pagination
              sx={{ justifyContent: 'center' }}
              color="primary"
              count={itemCountPagination}
              page={pagePagination}
              onChange={changePaginationPage}
              showFirstButton
              showLastButton
            />
          </Box>
        </>
      ) : (
        <Div>{'No hay codigos disponibles...'}</Div>
      )}
    </>
  );
};
